"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var UIBreadcrumbs = _react.default.createClass({
  displayName: "UIBreadcrumbs",
  propTypes: {
    children: _propTypes.default.node,
    flush: _propTypes.default.bool.isRequired,
    singleBreadcrumbIsBackLink: _propTypes.default.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      flush: false,
      // for backwards compat, this will be true in next major version
      role: 'navigation',
      singleBreadcrumbIsBackLink: true
    };
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className,
        flush = _ref.flush;
    return (0, _classnames.default)('private-breadcrumbs', className, {
      'private-breadcrumbs--flush': flush
    });
  },
  renderIcon: function renderIcon(isBackLink) {
    return _react.default.createElement(_UIIcon.default, {
      className: (0, _classnames.default)('private-breadcrumbs__arrow', {
        'private-breadcrumbs__arrow--back': isBackLink
      }),
      name: isBackLink ? 'left' : 'right'
    });
  },
  renderBreadcrumb: function renderBreadcrumb(children, _ref2) {
    var hasArrow = _ref2.hasArrow,
        isBackLink = _ref2.isBackLink;
    var icon = hasArrow ? this.renderIcon(isBackLink) : null;
    return _react.default.createElement("span", null, icon, children);
  },
  renderChildren: function renderChildren(_ref3) {
    var _this = this;

    var children = _ref3.children,
        singleBreadcrumbIsBackLink = _ref3.singleBreadcrumbIsBackLink;

    var isValidChild = function isValidChild(child) {
      if (typeof child === 'string') {
        return child.trim().length > 0;
      }

      return child;
    };

    var childrenArray = _react.default.Children.toArray(children);

    var validChildren = childrenArray.filter(isValidChild);
    var isOnlyChild = validChildren.length === 1;

    var breadcrumbs = _react.Children.map(validChildren, function (child, index) {
      var ariaCurrent = !isOnlyChild && index === validChildren.length - 1 ? 'location' : null;
      var isBackLink = isOnlyChild && singleBreadcrumbIsBackLink;
      var hasArrow = isBackLink || index !== 0;

      if ((0, _react.isValidElement)(child)) {
        return (0, _react.cloneElement)(child, {
          'aria-current': ariaCurrent,
          children: _this.renderBreadcrumb(child.props.children, {
            hasArrow: hasArrow,
            isBackLink: isBackLink
          }),
          className: 'private-breadcrumbs__item',
          key: index
        });
      }

      return _react.default.createElement("span", {
        "aria-current": ariaCurrent,
        className: "private-breadcrumbs__item"
      }, _this.renderBreadcrumb(child, {
        hasArrow: hasArrow,
        isBackLink: isBackLink
      }));
    });

    if (isOnlyChild && !singleBreadcrumbIsBackLink) {
      breadcrumbs.push(_react.default.createElement("span", {
        className: "private-breadcrumbs__item",
        key: "x"
      }, this.renderBreadcrumb(null, {
        hasArrow: true,
        isBackLink: false
      })));
    }

    return breadcrumbs;
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        flush = _this$props.flush,
        role = _this$props.role,
        singleBreadcrumbIsBackLink = _this$props.singleBreadcrumbIsBackLink,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "children", "flush", "role", "singleBreadcrumbIsBackLink"]);
    return _react.default.createElement("nav", (0, _extends2.default)({}, rest, {
      className: this.getClassName({
        className: className,
        flush: flush
      }),
      role: role
    }), this.renderChildren({
      children: children,
      singleBreadcrumbIsBackLink: singleBreadcrumbIsBackLink
    }));
  }
});

var _default = UIBreadcrumbs;
exports.default = _default;
module.exports = exports.default;